export default "__VITE_ASSET__B1r_lXHe__"